import React from "react";

import styled from "styled-components";

import { colorTheme } from "@utils";

import Button from "../Button/Button";
import DropDown from "../DropDown/DropDown";

const StyledTableActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100%;

  i {
    padding: 0 8px;
    color: ${colorTheme("neutral")};

    &:hover {
      color: ${colorTheme("neutralL1")};
      cursor: pointer;
    }
  }
`;

interface TableActionsProps {
  direction: "left" | "right" | "up" | "down";
  items: {
    title: string;
    visible?: boolean;
    onClick: () => void;
    icon?: string;
  }[];
  testId?: string;
  useButton?: boolean;
}

const TableActions = ({
  direction,
  items,
  testId = "table-actions",
  useButton,
}: TableActionsProps) => (
  <StyledTableActions>
    <DropDown direction={direction} testId={`${testId}-dropdown`}>
      <DropDown.Toggle>
        {useButton ? (
          <Button small icon="fa-solid fa-ellipsis" variant="secondary" />
        ) : (
          <i className="fa-solid fa-ellipsis" />
        )}
      </DropDown.Toggle>
      <DropDown.Menu>
        {items.length > 0 ? (
          items
            .filter((item) => !("visible" in item) || item.visible)
            .map((item) => (
              <DropDown.Item
                key={item.title}
                value={item.title}
                onClick={item.onClick}
              >
                {item.icon && (
                  <i
                    className={`fa-solid ${item.icon}`}
                    style={{ width: 25 }}
                  />
                )}
                {item.title}
              </DropDown.Item>
            ))
        ) : (
          <div style={{ padding: 10 }}>No actions available</div>
        )}
      </DropDown.Menu>
    </DropDown>
  </StyledTableActions>
);

export default TableActions;
